export const VALID_ROLES = [
  "super_admin",
  "admin",
  "reseller",
  "editor",
  "tenant_admin",
  "sales",
  "broker",
  "external_broker",
  "viewer",
];

export const ROLE_DEFINITIONS = {
  super_admin:     { label: "Super Admin",     group: "platform",    desc: "Full platform access" },
  admin:           { label: "Admin",           group: "platform",    desc: "Manages platform operations" },
  reseller:        { label: "Reseller",        group: "platform",    desc: "Manages projects under own scope" },
  editor:          { label: "Editor",          group: "structure",   desc: "Visual team — creates and edits project structure, publishes" },
  tenant_admin:    { label: "Tenant Admin",    group: "commercial",  desc: "Manages commercial layer: prices, availability, promotions" },
  sales:           { label: "Sales",           group: "commercial",  desc: "Views and shares projects, manages leads" },
  broker:          { label: "Broker",          group: "commercial",  desc: "Access assigned projects, view availability, share links" },
  external_broker: { label: "External Broker", group: "commercial",  desc: "Assigned projects only, no internal panels" },
  viewer:          { label: "Viewer",          group: "readonly",    desc: "Read-only access" },
};

export const ROLE_GROUPS = [
  { key: "platform",   label: "Platform",          roles: ["super_admin", "admin", "reseller"] },
  { key: "structure",  label: "Project Structure",  roles: ["editor"] },
  { key: "commercial", label: "Commercial Layer",   roles: ["tenant_admin", "sales", "broker", "external_broker"] },
  { key: "readonly",   label: "Read-Only",          roles: ["viewer"] },
];

export const ROLE_GROUP_STYLES = {
  platform:   "bg-blue-500/10 text-blue-400 border-blue-500/20",
  structure:  "bg-violet-500/10 text-violet-400 border-violet-500/20",
  commercial: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  readonly:   "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
};

// Roles that tenant_admins are allowed to assign
export const COMMERCIAL_ROLES = ["tenant_admin", "sales", "broker", "external_broker", "viewer"];

// Panel separation
export const CLIENT_ROLES = ["tenant_admin", "sales", "broker", "external_broker", "viewer"];
export const ADMIN_ROLES  = ["super_admin", "admin", "editor", "reseller"];
